<template>
	<div>
		<div 
			v-show="showLabel"
			v-on:click.prevent="showSelect"
			:class="{'text-center text-truncate':true, 'c-pointer':validateData}"
			style="height:28.9px">
			<small class="font-weight-bold">
				{{auth.cliente.DESCRIPCION || nameVal}}
			</small>
		</div>
		<div v-show="!showLabel">
			<select
				v-if="!loading"
		    	class="normal custom-select custom-select-sm" 
		    	v-model="auth.CODIGO_CLIENTE"
		    	@change="changeCliente">
		    	<option 
		    		v-for="item in clientes" 
		    		:value="item.CODIGO_CLIENTE">
		    		{{item.DESCRIPCION}}
		    	</option>
		    </select>
		    <div 
		    	v-else
		    	class="text-center text-truncate">
		    	<small class="font-weight-bold">
					{{mensaje}}
				</small>
		    	
		    </div>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['name'],

		mounted() {
			this.getAuth();
			this.getSegmentos();
	    },

	    data(){
        	return {
        		clientes: [],
        		showLabel: true,
        		validateData: false,
        		loading: false,
        		mensaje: 'cargando...',
        		auth: {
        			CODIGO_USUARIO: '',
					NOMBRE: '',
					PERFIL: '',
					CORREO: '',
					SEXO: '',
					ESTADO: '',
					FECHA_NACIMIENTO: '',
					FECHA_CREACION: '',
					FECHA_ACTUALIZACION: '',
					CREADO_POR: '',
					ACTUALIZADO_POR: '',
					CREADO_DESDE: '',
					ACTUALIZADO_DESDE: '',
					AVATAR_URL: '',
					MODE_TEMPLATE: '',
					PORTADA: '',
					CODIGO_CLIENTE: '',
					cliente: {
						CODIGO_CLIENTE: '',
						DESCRIPCION: '',
					}
        		}
        	}
        },

        computed: {
        	nameVal: function(){
        		return this.name
        	}
        },

        methods: {
        	getSegmentos: function(){
        		this.loading = true;
        		this.mensaje = 'cargando...';
				var url = '/api/clientes-bases/index';
				axios.get(url).then(response => {
					this.clientes = response.data;
					if(this.clientes.length>1){
						this.validateData = true;
					}
				}).catch(error =>{
				  console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			getAuth: function(){
				var url = '/api/auth';
				axios.get(url).then(response => {
					this.auth.CODIGO_USUARIO = response.data.CODIGO_USUARIO;
					this.auth.NOMBRE = response.data.NOMBRE;
					this.auth.PERFIL = response.data.PERFIL;
					this.auth.CORREO = response.data.CORREO;
					this.auth.SEXO = response.data.SEXO;
					this.auth.ESTADO = response.data.ESTADO;
					this.auth.FECHA_NACIMIENTO = response.data.FECHA_NACIMIENTO;
					this.auth.FECHA_CREACION = response.data.FECHA_CREACION;
					this.auth.FECHA_ACTUALIZACION = response.data.FECHA_ACTUALIZACION;
					this.auth.CREADO_POR = response.data.CREADO_POR;
					this.auth.ACTUALIZADO_POR = response.data.ACTUALIZADO_POR;
					this.auth.CREADO_DESDE = response.data.CREADO_DESDE;
					this.auth.ACTUALIZADO_DESDE = response.data.ACTUALIZADO_DESDE;
					this.auth.AVATAR_URL = response.data.AVATAR_URL;
					this.auth.MODE_TEMPLATE = response.data.MODE_TEMPLATE;
					this.auth.PORTADA = response.data.PORTADA;
					this.auth.CODIGO_CLIENTE = response.data.CODIGO_CLIENTE;
					if(response.data.cliente){
						this.auth.cliente.CODIGO_CLIENTE = response.data.cliente.CODIGO_CLIENTE;
						this.auth.cliente.DESCRIPCION = response.data.cliente.DESCRIPCION;
					}

				}).catch(error =>{
				  console.log(error.response);
				});
			},

			showSelect: function(){
				if(this.validateData){
					this.showLabel = !this.showLabel;
				}
			},

			changeCliente: function(){
				this.loading = true;
				this.mensaje = 'cargando...';
				var url = '/api/clientes-bases/change';
				axios.post(url, {
					'codigo_cliente': this.auth.CODIGO_CLIENTE
				}) 
				.then(response => {
					this.$toasted.show('Se ha cambiado de cliente');
					this.$toasted.show('Actualizando página...');
					this.mensaje = 'Actualizando página...';
					location.reload();
				}).catch(error =>{
			  		console.log(error.response);
			  		this.getAuth();
			  		this.$toasted.show('Error al actualiar cliente');
			  		this.loading = false;
				});	
			}
        }
	}
</script>